export default __webpack_public_path__ + "static/media/31_photo.811732a6.jpg";